import { HttpContextToken } from '@angular/common/http';

/** Internal capability for the current bootstrap request, never a URL bypass. */
export const RECOVERY_GENERATION = new HttpContextToken<number | null>(() => null);
/** Hold a meeting's credential until startup verifies its identity. */
export const PRESERVE_RECOVERY_IDENTITY = new HttpContextToken<boolean>(() => false);
